<div class="dialog-title">
    <h4 class="localization-form-title" *ngIf="!isViewMode">Activate User</h4>
    <button class="close-btn" mat-button (click)="closeDialog()">x</button>
</div>

<ng-container *ngIf="isViewMode">
    {{ data.userId }}

    <button (click)="onSubmit()">Activate</button>
</ng-container>
<ng-container *ngIf="!isViewMode">
    {{ data.userId }} is active

    <button (click)="closeDialog()">OK</button>
</ng-container>

<div *ngIf="errorMessage" class="error">
    <p>{{ (errorMessage | async)?.statusText }}</p>
</div>
